import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import Api from "../../services/api";
import swal from "sweetalert";
import SelectCidades from "../../components/SelectCidades";

const image_formats = ["image/jpg", "image/jpeg", "image/png", "image/webp"];

export default function EditMidia({ data, loadMidia, setOpenModalEdit }) {
  const [loading, setLoading] = useState(false);
  const Loader = () => <div className="loading"></div>;
  const [tipo, setTipo] = useState(data.tipo || "foto");
  const [cidadeId, setCidadeId] = useState(String(data.cidade_id || ""));
  const [videoUrl, setVideoUrl] = useState(data.video_url || "");
  const [legenda, setLegenda] = useState(data.legenda || "");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!cidadeId) return setError("Cidade obrigatória.");

    const body = new FormData();
    body.append("id", data.id);
    body.append("cidade_id", cidadeId);
    body.append("tipo", tipo);
    body.append("legenda", legenda);
    if (data.arquivo) body.append("oldimage", data.arquivo);

    if (tipo === "foto") {
      const fileInput = document.querySelector("#arquivo-edit");
      const file = fileInput && fileInput.files[0];
      if (file) {
        if (file.size > 5 * 1024 * 1024)
          return setError("Imagem maior que 5MB.");
        if (!image_formats.includes(file.type))
          return setError("Formato inválido (jpg, png, webp).");
        body.append("arquivo", file);
      }
    } else {
      if (!videoUrl || !/^https?:\/\//i.test(videoUrl))
        return setError("URL de vídeo inválida.");
      body.append("video_url", videoUrl);
    }

    setLoading(true);
    Api.post("/albatrozmidia/edit", body, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((response) => {
        if (response.data.status === "success") {
          swal("Sucesso!", response.data.message, "success");
          loadMidia();
          setOpenModalEdit(false);
        } else {
          swal("Erro!", response.data.message || "Erro", "error");
        }
        setLoading(false);
      })
      .catch((err) => {
        swal("Erro!", "ops! ocorreu um erro: " + err, "error");
        setLoading(false);
      });
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <h2>Editar mídia</h2>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <Grid container className="form">
          <Grid item lg={12} md={12} sm={12} xs={12} className="field">
            <label>Cidade</label>
            <SelectCidades
              valueSelected={cidadeId}
              register={{
                onChange: (e) => setCidadeId(e.target.value),
                onBlur: () => {},
                name: "cidade_id",
                ref: () => {},
              }}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12} className="field">
            <label>Tipo</label>
            <div style={{ display: "flex", gap: 16 }}>
              <label>
                <input
                  type="radio"
                  value="foto"
                  checked={tipo === "foto"}
                  onChange={() => setTipo("foto")}
                />{" "}
                Foto
              </label>
              <label>
                <input
                  type="radio"
                  value="video"
                  checked={tipo === "video"}
                  onChange={() => setTipo("video")}
                />{" "}
                Vídeo (URL)
              </label>
            </div>
          </Grid>
          {tipo === "foto" ? (
            <>
              {data.arquivo && (
                <Grid item lg={12} md={12} sm={12} xs={12} className="field">
                  <img
                    src={process.env.REACT_APP_FILES_URL + data.arquivo}
                    alt=""
                    style={{ maxHeight: 120 }}
                  />
                </Grid>
              )}
              <Grid item lg={12} md={12} sm={12} xs={12} className="field">
                <label>Trocar imagem (opcional)</label>
                <input type="file" name="arquivo" id="arquivo-edit" />
              </Grid>
            </>
          ) : (
            <Grid item lg={12} md={12} sm={12} xs={12} className="field">
              <label>URL do vídeo</label>
              <input
                type="text"
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
              />
            </Grid>
          )}
          <Grid item lg={12} md={12} sm={12} xs={12} className="field">
            <label>Legenda</label>
            <input
              type="text"
              value={legenda}
              onChange={(e) => setLegenda(e.target.value)}
            />
          </Grid>
          {error && <span className="error">{error}</span>}
        </Grid>
        <div className="actions">
          <button type="submit" className="save">
            Salvar
          </button>
          <a
            href="#"
            className="cancel"
            onClick={(e) => {
              e.preventDefault();
              setOpenModalEdit(false);
            }}
          >
            Cancelar
          </a>
        </div>
      </form>
    </>
  );
}
